import { render } from "./SinComisionesNew.vue?vue&type=template&id=8e968636&scoped=true"
import script from "./SinComisionesNew.vue?vue&type=script&lang=js"
export * from "./SinComisionesNew.vue?vue&type=script&lang=js"

import "./SinComisionesNew.vue?vue&type=style&index=0&id=8e968636&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e968636"]])

export default __exports__